import { createSlice, configureStore } from "@reduxjs/toolkit";

const appSlice = createSlice({
    name: 'store',

    initialState: {
        url: process.env.REACT_APP_API_URL,
        tenants: [],
        landlords: [],
        currentUser: null,
        transactions: [],
        loanApplications: [],
        loanReviews: []
    },

    reducers: {
        updateTransactions(state, action) {
            state.transactions = action.payload;
        },

        updateTenants(state, action) {
            state.tenants = action.payload;
        },

        updateUser(state, action) {
            state.currentUser = action.payload;
        },

        updateLoanApplications(state, action) {
            state.loanApplications = action.payload;
        },

        updateLoanReviews(state, action) {
            state.loanReviews = action.payload;
        }
    }
});

const store = configureStore({
    reducer: appSlice.reducer
});

export const actions = appSlice.actions;
export default store;